<template>
    <div class="map">
        <div class="crewroom"></div>
        <div class="library"></div>
    </div>
</template>

<script>
    export default {
        name: 'Map'
    
    }
</script>

<style lang="scss" scoped>
.crewroom{
    
}

.library{
    background-color: white;
    height: 15vh;
    width: 10vw;
    border-radius: 5px;
    transform: rotate(33deg);
}
</style>